import CheckboxInput from 'components/forms/inputs/rhf-inputs/CheckboxInput.tsx';
import NumberInput from 'components/forms/inputs/rhf-inputs/NumberInput';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import TranslationsInput from 'components/forms/inputs/translations/TranslationsInput';
import InfoTooltip from 'components/InfoTooltip';
import { Controller } from 'react-hook-form';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { JobRoleFormState } from './useJobRoleForm';

/** The order number, names, abbreviation and category. */
export const JobRoleFields = ({ form }: { form: JobRoleFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    return (
        <>
            <NumberInput
                control={control}
                label="order-number"
                placeholder="forms.enter-order-number"
                name="orderNum"
                rightLabelComponent={<InfoTooltip text={'job-roles.tooltips.order-number'} />}
                required
                validate={form.greaterThanZero}
            />
            <TextInput control={control} label="public-name" placeholder="forms.enter-name" name="name" required />
            <TextInput
                control={control}
                label="job-roles.internal-name"
                placeholder="forms.enter-internal-name"
                name="internalName"
                required
            />
            <TextInput
                control={control}
                label="job-roles.abbreviation"
                placeholder="forms.enter-abbreviation"
                name="abbreviation"
                maxLength={255}
            />
            <SelectInput
                setValue={setValue}
                control={control}
                label="category"
                placeholder="forms.select-category"
                name="groupNameType"
                options={
                    (getValidOptionsFromClassifier(form.classifiers['JOB_ROLE_GROUP_TYPE']) as {
                        label: string;
                        value: string;
                    }[]) ?? []
                }
                getOptionLabel="label"
                getOptionIdentifier="value"
                rightLabelComponent={<InfoTooltip text={'job-roles.tooltips.category'} />}
                required
            />
        </>
    );
};

/** Active, and what the role is left out of. */
export const JobRoleSettingsFields = ({ form }: { form: JobRoleFormState }): JSX.Element => {
    const { control } = form.methods;
    return (
        <>
            <CheckboxInput control={control} name="isActive" label="employees.is-active" />
            <CheckboxInput
                control={control}
                name="excludeFromMinmaxCalculation"
                label="job-roles.exclude-from-minmax-calculation"
            />
        </>
    );
};

/** The public name in each language. */
export const JobRoleTranslationsFields = ({ form }: { form: JobRoleFormState }): JSX.Element => {
    const { control, getValues } = form.methods;
    return (
        <Controller
            control={control}
            name="entityTexts"
            render={({ field }) => (
                <TranslationsInput
                    labelId="job-roles.public-name-translations"
                    classifiers={form.classifiers}
                    control={control}
                    entityTexts={field.value ?? []}
                    getValues={getValues}
                />
            )}
        />
    );
};
